import { Row } from "antd";
import { ReactElement } from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../../assets/logo_1.png";

const NoAuthLayout = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <Row className="flex flex-col items-center justify-center bg-white lg:bg-[#f8f9fa] !max-w-screen !min-h-screen flex-nowrap whitespace-nowrap">
      <Row
        style={{ position: "fixed", top: 0 }}
        className="z-10 w-full h-[60px] bg-[#f8f9fa] lg:bg-white flex items-center justify-center"
      >
        <img
          src={logo}
          alt=""
          className="w-[50px] h-[50px] cursor-pointer"
          onClick={(): void => {
            window.location.reload();
          }}
        />
        <Row className="flex flex-col justify-center items-center ml-2">
          <Row className="text-[14px] lg:text-[18px] font-semibold text-gray-700">
            {t("header.logo-2")}
          </Row>
        </Row>
      </Row>
      <Outlet />
    </Row>
  );
};

export default NoAuthLayout;
